<template>
    <div class="dynamic-wrapper wrapper">
        <div class="logo">
            <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du7590crdaf15jp2g79j8nfd9.png" alt="">
        </div>
        <h3 class="title">
            <img :src="year == 2019 ? 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2711kb1rtd1j281rcb170r4g.png' : 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm288jjn4t9ktb9620h4n.png'" alt="">
        </h3>
        <div class="dynamic-inner" v-if="detailData">
            <div class="dynamic-user">
                <div class="img"><img :src="detailData.avatar || 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dueg5elo1i4u1l5q1tkrs1713lb9.jpg'" alt=""></div>                
                <span v-html="detailData.nick_name"></span>
            </div>
            <p v-html="formatContent(detailData.content)"></p>
            <div class="imgs" v-if="detailData.pics">
                <div class="img" @click="previewImage(index, JSON.parse(detailData.pics))" v-for="(item, index) in JSON.parse(detailData.pics)" :key="index">
                    <img :src="item.pic_url.indexOf('?') > -1 ? item.pic_url + '&imageView2/1/w/200/h/200' : item.pic_url + '?imageView2/1/w/200/h/200'" alt="">
                </div>
            </div>
            <div class="video" v-if="detailData.video_detail" :class="[isAndroid && versionSize >= 570 && 'video-android']" @click="videoClick(detailData.video_detail)">
                <video v-if="!isAndroid || versionSize < 570" :src="detailData.video_detail.video_url" controlslist="nodownload" @play="videoPlay" @pause="videoPaused" :poster="detailData.video_detail.img_url" controls="controls"></video>
                <img v-else :src="detailData.video_detail.img_url" alt="">
            </div>
        </div>
    </div>
</template>

<script>

import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'dynamic',
    data() {
        return {
            year: 2019,
            id: 0,
            detailData: null,
            isMusicPlay: true,
            isAndroid: false
        }
    },
    computed: {
      ...mapState(['aid', 'isImmerse', 'shareData', 'userinfo', 'versionSize'])
    },
    created() {
        this.year = this.$route.query.year
        this.id = this.$route.query.id
        this.getDetial()
    },
    mounted() {
        this.checkTimeAsync().then(()=> {
            this.share()
        })
        this.isAndroid = COVERAPP.Attribute.isAndroid()
        this.setPageLoadingAsync(false)
        document.querySelector('.loading-wrap').style.display = 'none'	
        COVER.track(this.aid, 'load', '动态详情页面加载')
    },
    methods: {
        ...mapActions([
            'checkCanGetHb',
            'checkTimeAsync',
            'setPageLoadingAsync'
        ]),
        getDetial() {
            COVER.ajax('/wap/wapTopic/dynamicDetail', {
                dynamic_id: this.id 
            }).then(res=> {
                if(res.data && res.data.status == 0 && res.data.data && res.data.data.dynamicInfo) {
                    this.detailData = res.data.data.dynamicInfo
                }
            })
        },
        formatContent(content) {
            content = content.replace(/<(?:.|\s)*?>/g, '').replace(/[\n\r]/g, "<br/>").replace(/↵/g, "<br/>");
            return COVER.renderReplyContent(content);
        },
        videoPlay() {
            let music = document.querySelector('#music')
            this.isMusicPlay = !music.paused
            if(this.isMusicPlay) {
                music.pause()
            }
        },
        videoPaused() {
            let music = document.querySelector('#music')
            if(this.isMusicPlay) {
                music.play()
            }
        },
        previewImage(current, urls){
            let urlArr = [];
            urls.forEach(element => {
                urlArr.push(element.pic_url);
            });
            if(COVERAPP.Attribute.isApp()){
                COVERAPP.UI.previewImage({
                    current: current,
                    urls: urlArr
                });
            }else if(COVERAPP.Attribute.isWeixin()){
                COVER.openapi.weixin.wx_previewImage({
                    current: urlArr[current], // 当前显示图片的http链接
                    urls: urlArr // 需要预览的图片http链接列表
                })
            }
        },
        share() {
            let _this = this
            let ShareData = JSON.parse(JSON.stringify(this.shareData))
            ShareData.callback = function(ret) {
                var data = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret;
                var origin = data.origin || '';
				if(origin != 'None' && !COVER.isEmpty(origin)){
					COVER.track(_this.aid, 'share', '分享链接到'+origin);  
				} else {
					COVER.track(_this.aid, 'share', '分享'); 
                } 
                if((data.status == 'success' || data.status == '1') && _this.userinfo.user_id){
                    _this.checkCanGetHb(2).then(()=> {
                        COVER.track(_this.aid, 'load', '红包雨页面加载')
                        _this.$router.push('/game?type=2')
                    })
                }           
            }
            if (!this.isImmerse) {
                COVER.share(ShareData)
            }
        },
        videoClick(data) {
            if(this.isAndroid && this.versionSize >= 570) {
                let _this = this
                let music = document.querySelector('#music')
                this.isMusicPlay = !music.paused
                if(this.isMusicPlay) {
                    music.pause()
                }
                COVERAPP.Method.goVideoPlay({
                    id: data.dynamic_id,
                    url: data.video_url,
                    callback(ret) {
                        let data = typeof ret == 'object'.toLowerCase() ? JSON.stringify(ret) : ret;
                        if(_this.isMusicPlay) {
                            music.play()
                        }
                    }
                })
            }
        }
    }
}
</script>

<style lang="less">
    .dynamic-wrapper {
        min-height: 100vh;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261jtb13ff1b8m1mrkett2q.jpg) no-repeat center top;
        background-size: 100% auto;
        position: relative;
        &::before, &::after {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            content: '';
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261q7b108pn9do2r4h2p.jpg) no-repeat center bottom;
            background-size: 100% auto;
        }
        &:before {
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28k2417secqqu9vqd44o.jpg) no-repeat center top;
            background-size: 100% auto;
        }
        .logo {
            position: relative;
            z-index: 2;
        }
        .title {
            padding-top: 1.384863rem;
            position: relative;
            z-index: 2;
        }
    }
    .dynamic-inner {
        margin: 0 .805153rem;
        background-color: #f8d196;
        box-shadow: 0 .161031rem .080515rem rgba(0,0,0,0.2);
        padding: .442834rem .603865rem .563607rem;
        border-radius: .241546rem;
        overflow: hidden;
        position: relative;
        z-index: 2;
        p {
            color: #e6352b;
            font-size: .273752rem;
            line-height: 1.5;
            img {
                width: .322061rem;
                vertical-align: middle;
            }
        }
        .imgs {
            margin-top: .402576rem;
            overflow: hidden;
            width: 110%;
            .img {
                width: 2.270531rem;
                height: 2.270531rem;
                float: left;
                overflow: hidden;
                margin: 0 .193237rem .193237rem 0;
                text-align: center;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    width: auto;
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
        .video {
            margin-top: .402576rem;
            height: 4.05rem;
            background-color: #000;
            position: relative;
            video {
                width: 100%;
                height: 100%;
                background-color: #000;
            }
            img {
                max-width: 100%;
                width: auto;
                max-height: 100%;
                position: relative;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
            &.video-android {
                &::after {
                    content: '';
                    width: 1.1rem;
                    height: 1.1rem;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    -webkit-transform: translate(-50%, -50%);
                    background: url(https://wapcdn.thecover.cn/wap/5.0.0/img/user_video_btn.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .dynamic-user {
        display: flex;
        align-items: center;
        margin-bottom: .217391rem;
        .img {
            background-color: #e6352b;
            width: .756844rem;
            height: .756844rem;
            border-radius: 50%;
            overflow: hidden;
        }
        span {
            color: #e6352b;
            font-size: .354267rem;
            font-weight: bold;
            margin-left: .193237rem;
        }
    }
</style>